import { render, staticRenderFns } from "./EditPrivateEmailModal.vue?vue&type=template&id=420746e1&scoped=true&"
import script from "./EditPrivateEmailModal.vue?vue&type=script&lang=js&"
export * from "./EditPrivateEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPrivateEmailModal.vue?vue&type=style&index=0&id=420746e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420746e1",
  null
  
)

export default component.exports